


















































































import Vue from "vue";
import Component from "vue-class-component";
import { Emit } from "vue-property-decorator";
import AppTextField from "#/components/AppTextField.vue";
import { PORTAL_JOBSEARCH_APPLICATION_SELECTION_STATUS } from "@/consts/portal";

export interface JobsearchApplicationSearchParams {
  code?: string;
  portal_office_name?: string;
  hst_no?: string;
  kst_no?: string;
  listing_no?: string;
  listing_title?: string;
  jst_no?: string;
  recruitee_name?: string;
  selection_statuses?: number[];
}

@Component({
  components: {
    AppTextField,
  },
})
export default class extends Vue {
  private code = "";
  private portal_office_name = "";
  private hst_no = "";
  private kst_no = "";
  private listing_no = "";
  private listing_title = "";
  private jst_no = "";
  private recruitee_name = "";
  private selection_statuses: number[] = [];
  private selectionStatusOptions =
    PORTAL_JOBSEARCH_APPLICATION_SELECTION_STATUS;

  @Emit()
  private search(): JobsearchApplicationSearchParams {
    const params: JobsearchApplicationSearchParams = {
      code: this.code,
      portal_office_name: this.portal_office_name,
      hst_no: this.hst_no,
      kst_no: this.kst_no,
      listing_no: this.listing_no,
      listing_title: this.listing_title,
      jst_no: this.jst_no,
      recruitee_name: this.recruitee_name,
      selection_statuses: this.selection_statuses,
    };
    return params;
  }
}
